<template>
    <div :style="[elementStyles, basicContentStyles]">
    </div>
</template>

<script>
    export default {
        props: ['data', 'frame', 'basicContentStyles', 'width', 'height'],
        data: function () {
            return {
            }
        },
        computed: {
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                return {
                    backgroundColor: this.data.primary_color,
                    opacity: opacity,
                }
            }
        }
    }
</script>
